var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import VueDialog from "../../interface/IVueDialog";
import Component from 'vue-class-component';
import LicenseService from "../../api/LicenseService";
import { ETestReportType } from "../../enum/ELicense";
import LicenseFileList from './components/LicenseFileList';
var LicenseDetailDialog = (function (_super) {
    __extends(LicenseDetailDialog, _super);
    function LicenseDetailDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.eTestReportType = ETestReportType;
        _this.document_id = null;
        _this.license = {};
        _this.viewImgDefaultIndex = 0;
        return _this;
    }
    LicenseDetailDialog.prototype.created = function () {
        this.service = LicenseService.getInstance();
        this.getDetail();
    };
    LicenseDetailDialog.prototype.mounted = function () {
    };
    LicenseDetailDialog.prototype.getDetail = function () {
        var _this = this;
        var params = {
            document_id: this.document_id
        };
        this.service.getDetail(params).then(function (res) {
            if (res.data.success) {
                var data = res.data.data;
                _this.license = Object.assign({}, data);
            }
            else {
                _this.$message.error(res.data.msg);
            }
        });
    };
    LicenseDetailDialog = __decorate([
        Component({
            components: {
                LicenseFileList: LicenseFileList
            }
        })
    ], LicenseDetailDialog);
    return LicenseDetailDialog;
}(VueDialog));
export default LicenseDetailDialog;
